(function () {
  const config = {
    experimentName: 'WU-17637 | Cart Progress to Unlock Free Shipping V2',
    experimentId: '2bfcd9c5-1cc7-4026-95f9-c5e00d5ad2c8',
    groupIds: [
      '4f0f1c8d-14cf-470d-9e16-ee237d86b685', // Control
      '94a050b3-25bf-4b7e-b6c2-4b8524028104', // Version
    ],
    debug: false,
  };
  let listenersActive = false;
  let triggered = false;

  const log = (...args) => config.debug && console.log('[IG ATC Test]', ...args);

  window.igAtcClicked = false;
  log('igAtcClicked initialized to false');

  function fireTrigger() {
    if (triggered) return;
    triggered = true;

    window.igAtcClicked = true;
    log('igAtcClicked set to true');

    const randomGroupId = config.groupIds[Math.floor(Math.random() * config.groupIds.length)];
    log('Attempting assignTestGroup — experimentId:', config.experimentId, '| groupId:', randomGroupId);
    log('igData.user available:', !!window.igData?.user);
    log('assignTestGroup available:', typeof window.igData?.user?.assignTestGroup);

    window.igData?.user
      ?.assignTestGroup?.(config.experimentId, randomGroupId)
      ?.then((res) => {
        log('Assigned successfully:', JSON.stringify(res));
        log('Firing page view beacon via restart()');
        window.igData?.restart?.();
      })
      ?.catch((err) => log('Assignment error:', err?.message || err));
  }

  function bindAtcListeners() {
    if (listenersActive) return;
    listenersActive = true;

    document.addEventListener(
      'click',
      function (e) {
        const atcBtn = e.target.closest(
          [
            'button[name="add"]',
            '[name="add"] button',
            '.product-form__submit',
            '[data-submit-button]',
            '[data-add-to-cart]',
            '#picker-submit_button-sub',
            '#picker-checkout_button',
            '#picker-submit_button-otp',
            '#picker-submit_button-otp-checkout',
            '[data-otp-button]',
            '[data-otp-checkout-button]',
          ].join(', ')
        );
        if (!atcBtn) return;
        log('Button matched:', atcBtn.id || atcBtn.className || atcBtn.tagName);
        fireTrigger();
      },
      true
    );

    document.addEventListener(
      'submit',
      function (e) {
        const form = e.target.closest('form[action*="/cart/add"]');
        if (!form) return;
        log('Form submit matched');
        fireTrigger();
      },
      true
    );

    log('ATC listeners bound');
  }

  bindAtcListeners();
})();
